import { render, staticRenderFns } from "./ReferenceFactImport.vue?vue&type=template&id=0a8e33da&scoped=true"
import script from "./ReferenceFactImport.vue?vue&type=script&lang=js"
export * from "./ReferenceFactImport.vue?vue&type=script&lang=js"
import style0 from "./ReferenceFactImport.vue?vue&type=style&index=0&id=0a8e33da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8e33da",
  null
  
)

export default component.exports